(function (global) {
  'use strict';

  function normalizeTitle(value) {
    return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function optionNames(product) {
    return (product && (product.optionNames || product.options) || []).map(function (option) { return typeof option === 'string' ? option : option.name || ''; });
  }

  function variantOptions(variant) {
    if (!variant) return [];
    return Array.isArray(variant.options) ? variant.options.map(String) : String(variant.title || '').split(/\s*\/\s*/);
  }

  function variantForOptions(variants, selected) {
    if (!selected.length || selected.some(function (value) { return value === undefined || value === null || value === ''; })) return null;
    return (variants || []).find(function (variant) {
      var options = variantOptions(variant);
      return options.length === selected.length && options.every(function (value, index) { return String(value) === String(selected[index]); });
    }) || null;
  }

  function optionExists(variants, selected, index, value) {
    // Earlier options constrain later options. The first option always remains
    // navigable, avoiding a dead end when valid combinations are disjoint.
    return (variants || []).some(function (variant) {
      var options = variantOptions(variant);
      return options[index] === String(value) && options.slice(0, index).every(function (option, prior) { return String(option) === String(selected[prior]); });
    });
  }

  function variantColor(variant, product) {
    if (!variant) return '';
    if (variant.color !== undefined && variant.color !== null) return normalizeTitle(variant.color);
    var names = optionNames(product);
    var rawIndex = product && product.colorOptionIndex;
    var index = rawIndex !== undefined && rawIndex !== null && rawIndex !== '' ? Number(rawIndex) : names.findIndex(function (name) { return /^(color|colour|cor|couleur)$/i.test(String(name).trim()); });
    var options = variantOptions(variant);
    return Number.isInteger(index) && index >= 0 && index < options.length ? normalizeTitle(options[index]) : '';
  }

  function preferredVariant(variants) {
    return (variants || []).find(purchasable) || (variants || [])[0] || null;
  }

  function singleDefaultVariant(variants) {
    var options = variants && variants.length === 1 ? variantOptions(variants[0]) : [];
    return options.length === 1 && normalizeTitle(options[0]) === 'default title';
  }

  function matchingCompanion(main, variants, mainProduct, companionProduct) {
    if (!main) return null;
    var names = optionNames(companionProduct);
    if (names.length > 1 || (variants || []).some(function (variant) { return variantOptions(variant).length > 1; })) return null;
    if (singleDefaultVariant(variants)) return companionProduct && companionProduct.allowFallback === true && purchasable(variants[0]) ? variants[0] : null;
    var companionHasColor = (variants || []).some(function (variant) { return variantColor(variant, companionProduct); });
    if (names.length && !companionHasColor) return null;
    var color = variantColor(main, mainProduct);
    var byColor = color ? (variants || []).filter(function (variant) { return variantColor(variant, companionProduct) === color; }) : [];
    if (byColor.length) return preferredVariant(byColor);
    if (color && companionHasColor) return null;
    var title = normalizeTitle(main.title);
    var byTitle = (variants || []).filter(function (variant) { return normalizeTitle(variant.title) === title; });
    if (byTitle.length) return preferredVariant(byTitle);
    return null;
  }

  function purchasable(variant) {
    return Boolean(variant && variant.available === true);
  }

  function quantityOf(value, min, max) {
    var number = Math.floor(Number(value));
    var lower = Math.max(1, Number(min) || 1);
    var upper = Number(max) >= lower ? Math.floor(Number(max)) : 99;
    return Math.min(upper, Math.max(lower, Number.isFinite(number) ? number : lower));
  }

  function explicitSaving(subtotal, config) {
    var offers = [
      { threshold: Number(config.discountThreshold), percent: Number(config.discountPercent) },
      { threshold: Number(config.highDiscountThreshold), percent: Number(config.highDiscountPercent) }
    ].filter(function (offer) {
      return Number.isFinite(offer.threshold) && offer.threshold > 0 && Number.isFinite(offer.percent) && offer.percent > 0 && offer.percent < 100 && subtotal >= offer.threshold;
    });
    if (!offers.length) return null;
    var offer = offers.reduce(function (best, candidate) { return candidate.percent > best.percent ? candidate : best; });
    return { percent: offer.percent, amount: Math.round(subtotal * offer.percent / 100) };
  }

  function cartRoot(value) {
    var root = String(value || '/cart').replace(/\/+$/, '');
    // Cart actions remain on the current storefront, including a locale prefix.
    return /^\/(?!\/)[^?#]*\/cart$/.test(root) || root === '/cart' ? root : '/cart';
  }

  function validateAdded(response, requested) {
    if (!response || typeof response !== 'object' || Number(response.status) >= 400) return false;
    var lines = Array.isArray(response.items) ? response.items : (response.variant_id || response.id ? [response] : []);
    return requested.every(function (item) {
      return lines.reduce(function (sum, line) {
        return String(line.variant_id || line.id) === String(item.id) ? sum + (Number(line.quantity) || 0) : sum;
      }, 0) >= item.quantity;
    });
  }

  function fillTemplate(template, values) {
    return String(template || '').replace(/\{(\w+)\}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match;
    });
  }

  var ElementBase = global.HTMLElement || class {};
  class ChicMobilePilot extends ElementBase {
    connectedCallback() {
      if (this._initialized) return;
      var script = this.querySelector('[data-mobile-config]');
      if (!script) return;
      try {
        this.config = JSON.parse(script.textContent);
        this.product = this.config.product || {};
        this.variants = this.product.variants || [];
        this.images = this.config.images || this.product.images || [];
        this.companion = this.config.companion || this.product.companion || {};
        this.texts = this.config.texts || {};
        this.baseFacts = Array.isArray(this.product.facts) ? this.product.facts : Array.isArray(this.config.facts) ? this.config.facts : null;
        this._initialized = true;
        const size = new URL(global.location.href).searchParams.get('mobile_preview');
        if (global.innerWidth >= 750 && /^(360x640|375x667|390x844)$/.test(size || '')) {
          const [width, height] = size.split('x');
          this.style.width = width + 'px';
          this.style.maxWidth = width + 'px';
          this.style.height = height + 'px';
        }
        this._abort = new AbortController();
        this.addEventListener('click', this._onClick.bind(this), { signal: this._abort.signal });
        this.addEventListener('change', this._onChange.bind(this), { signal: this._abort.signal });
        this.addEventListener('input', this._onInput.bind(this), { signal: this._abort.signal });
        this.addEventListener('submit', this._onSubmit.bind(this), { signal: this._abort.signal });
        var checked = this.querySelector('input[name="mobile-color"]:checked');
        var nativeVariant = this._one('[data-selected-variant]');
        this.variant = this.variants.find(function (item) { return String(item.id) === String(checked ? checked.value : this.dataset.mainId || this.product.selectedVariantId || nativeVariant && nativeVariant.value); }, this) || preferredVariant(this.variants);
        this.selectedOptions = variantOptions(this.variant);
        var controls = this._all('[data-option-index]');
        if (controls.length) {
          controls.forEach(function (control) {
            var index = Number(control.dataset.optionIndex);
            if (Number.isInteger(index) && index >= 0 && (control.tagName === 'SELECT' || control.checked)) this.selectedOptions[index] = control.value;
          }, this);
          this.variant = variantForOptions(this.variants, this.selectedOptions);
        }
        this._sync(true);
        this.dataset.ready = 'true';
      } catch (error) {
        this._status(this.texts && this.texts.error || 'This selection could not be loaded. Please refresh the page.');
      }
    }

    disconnectedCallback() {
      if (this._abort) this._abort.abort();
      this._initialized = false;
    }

    _one(selector) { return this.querySelector(selector); }
    _all(selector) { return Array.from(this.querySelectorAll(selector)); }
    _text(selector, value) { var element = this._one(selector); if (element) element.textContent = value; }

    _money(cents) {
      try {
        return new Intl.NumberFormat(this.dataset.locale || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(Number(cents || 0) / 100);
      } catch (error) {
        return (Number(cents || 0) / 100).toFixed(2) + ' ' + (this.dataset.currency || 'USD');
      }
    }

    _quantity() {
      var input = this._one('[data-quantity]');
      return input ? quantityOf(input.value, input.min, input.max) : 1;
    }

    _image(selector, image, fallbackAlt) {
      var target = this._one(selector);
      if (!target || !image) return;
      var img = target.tagName === 'IMG' ? target : target.querySelector('img');
      if (!img) return;
      var source = typeof image === 'string' ? image : image.src || image.url;
      if (!source) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = source;
      img.alt = typeof image === 'object' && image.alt || fallbackAlt || '';
    }

    _setHero(image, index) {
      if (!image) return;
      this._image('[data-hero]', image, this.product.title || '');
      this._all('[data-thumb-index]').forEach(function (thumb) {
        var active = String(thumb.dataset.thumbIndex) === String(index);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        thumb.classList.toggle('is-active', active);
      });
      var current = this._one('[data-gallery-current]');
      if (current) {
        var number = Number(index);
        current.textContent = Number.isInteger(number) && number >= 0 && number < this.images.length ? (number + 1) + '/' + this.images.length : this.variant && this.variant.title || '';
      }
    }

    _syncFacts() {
      var target = this._one('[data-mobile-benefits]');
      if (!target) return;
      if (!this._baseBenefits) this._baseBenefits = Array.from(target.childNodes || []).map(function (node) { return node.cloneNode(true); });
      var supplied = this.variant && this.variant.facts;
      var facts = (Array.isArray(supplied) && supplied.length ? supplied : this.baseFacts);
      var clean = Array.isArray(facts) ? facts.map(function (fact) { return String(fact).trim(); }).filter(Boolean).slice(0, 3) : null;
      var key = clean ? JSON.stringify(clean) : 'server-rendered-base';
      if (key === this._factsKey) return;
      this._factsKey = key;
      if (clean && clean.length) {
        var doc = target.ownerDocument || global.document;
        target.replaceChildren.apply(target, clean.map(function (fact) {
          var item = doc.createElement('li');
          var check = doc.createElement('span');
          check.setAttribute('aria-hidden', 'true');
          check.textContent = '✓';
          item.appendChild(check);
          item.appendChild(doc.createTextNode(fact));
          return item;
        }));
      } else {
        target.replaceChildren.apply(target, this._baseBenefits.map(function (node) { return node.cloneNode(true); }));
      }
    }

    _sync(initial) {
      var variant = this.variant;
      this.selectedOptions = this.selectedOptions || variantOptions(variant);
      this.matched = matchingCompanion(variant, this.companion.variants, this.product, this.companion);
      var quantity = this._quantity();
      var subtotal = (Number(variant && variant.price) || 0) * quantity;
      var setSubtotal = subtotal + (Number(this.matched && this.matched.price) || 0);
      var title = variant && variant.title || this.selectedOptions.join(' · ');
      this._all('input[name="mobile-color"]').forEach(function (input) { input.checked = Boolean(variant && String(input.value) === String(variant.id)); });
      this._all('[data-option-index]').forEach(function (control) {
        var index = Number(control.dataset.optionIndex);
        if (!Number.isInteger(index) || index < 0) return;
        var selected = this.selectedOptions[index];
        if (control.tagName === 'SELECT') {
          control.value = selected === undefined ? '' : selected;
          Array.from(control.options || []).forEach(function (option) {
            option.disabled = !optionExists(this.variants, this.selectedOptions, index, option.value);
          }, this);
        } else if (control.type === 'radio') {
          control.checked = String(control.value) === String(selected);
        }
      }, this);
      this._text('[data-color-name]', title);
      this._syncFacts();
      this._text('[data-main-price]', variant ? this._money(variant.price) : this.texts.unavailable || 'Unavailable');
      this._text('[data-bundle-total]', variant && this.matched ? this._money(setSubtotal) : '—');
      this._image('[data-bundle-base]', variant && variant.image, this.product.title || '');
      var selectedVariant = this._one('[data-selected-variant]');
      if (selectedVariant) {
        selectedVariant.value = variant ? String(variant.id) : '';
        selectedVariant.disabled = !variant;
      }
      this._text('[data-companion-label]', this.companion.title ? this.companion.title + (this.matched ? ' · ' + this.matched.title : '') : '');
      this._text('[data-companion-variant]', this.matched ? this.matched.title : this.texts.unavailable || 'Unavailable');
      var image = this.matched && this.matched.image || this.companion.image;
      this._image('[data-companion-image]', image, this.companion.title || '');
      var note = this._one('[data-preorder-note]');
      if (note) note.hidden = !(variant && variant.preorder);
      var setNote = this._one('[data-bundle-preorder-note]');
      if (setNote) setNote.hidden = !(variant && variant.preorder || this.matched && this.matched.preorder);
      var gift = this._one('[data-included-gift]');
      if (gift) gift.hidden = !(this.product.excludeFromGift !== true && this.config.giftAvailable === true && Number(this.config.giftThreshold) > 0 && subtotal >= Number(this.config.giftThreshold));
      var giftOffer = this._one('[data-gift-offer]');
      if (giftOffer) giftOffer.hidden = Boolean(gift && !gift.hidden);
      var saving = this._one('[data-bundle-saving]');
      var offer = variant && this.matched ? explicitSaving(setSubtotal, this.config) : null;
      this._text('[data-bundle-estimate]', variant && this.matched ? this._money(setSubtotal - (offer ? offer.amount : 0)) : '—');
      const baseTotal = this._one('[data-bundle-total]');
      if (baseTotal) baseTotal.hidden = !offer;
      if (saving) {
        saving.hidden = !offer;
        saving.textContent = offer ? fillTemplate(this.texts.saving || 'Possible {percent}% savings: {amount}. Details at checkout.', { amount: this._money(offer.amount), percent: offer.percent }) : '';
      }
      this._buttons();
      if (initial || this._variantChanged) {
        var lifestyle = this.config.lifestyle || this.product.lifestyle;
        var useLifestyle = initial && variant && (String(variant.id) === String(this.config.lifestyleVariantId) || variantColor(variant, this.product) === 'purple' || !this.config.lifestyleVariantId && !variantColor(variant, this.product)) && lifestyle;
        var selectedImage = useLifestyle ? lifestyle : variant && variant.image || this.images[0];
        var imageSource = typeof selectedImage === 'string' ? selectedImage : selectedImage && (selectedImage.src || selectedImage.url);
        var selectedIndex = this.images.findIndex(function (item) { return (typeof item === 'string' ? item : item.src || item.url) === imageSource; });
        this._setHero(selectedImage, selectedIndex);
        this._variantChanged = false;
      }
    }

    _buttons() {
      var main = this._one('[data-main-submit]');
      var bundle = this._one('[data-bundle-submit]');
      var mainOk = purchasable(this.variant);
      var setOk = mainOk && purchasable(this.matched);
      var locked = Boolean(this._busy || this._alreadyAdded);
      this._all('input[name="mobile-color"]').forEach(function (input) { input.disabled = locked; });
      this._all('[data-option-index]').forEach(function (control) { control.disabled = locked; });
      this._all('[data-qty-step]').forEach(function (button) { button.disabled = locked; });
      var quantity = this._one('[data-quantity]');
      if (quantity) quantity.disabled = locked;
      if (main) {
        main.disabled = this._busy || this._alreadyAdded || !mainOk;
        main.setAttribute('aria-busy', this._busy ? 'true' : 'false');
        main.textContent = fillTemplate(this._busy ? this.texts.adding || 'Adding…' : !mainOk ? this.texts.unavailable || 'Unavailable' : (this.variant.preorder ? this.texts.preorder : this.texts.add) || 'Add to cart', { amount: this._money((Number(this.variant && this.variant.price) || 0) * this._quantity()) });
      }
      if (bundle) {
        bundle.disabled = this._busy || this._alreadyAdded || !setOk;
        bundle.setAttribute('aria-busy', this._busy ? 'true' : 'false');
        bundle.textContent = fillTemplate(this._busy ? this.texts.adding || 'Adding…' : !setOk ? this.texts.unavailable || 'Unavailable' : (this.variant.preorder || this.matched.preorder ? this.texts.preorder_set : this.texts.add_set) || 'Add set', { amount: this._money((Number(this.variant && this.variant.price) || 0) * this._quantity() + (Number(this.matched && this.matched.price) || 0)) });
      }
    }

    _onChange(event) {
      if (event.target.matches('[data-mobile-language]')) {
        const target = new URL(event.target.form.elements.return_to.value, global.location.origin);
        const size = new URL(global.location.href).searchParams.get('mobile_preview');
        if (size) target.searchParams.set('mobile_preview', size);
        event.target.form.elements.return_to.value = target.pathname + target.search;
        event.target.form.submit(); return;
      }
      if (event.target.matches('[data-option-index]')) {
        if (event.target.type === 'radio' && !event.target.checked) return;
        var index = Number(event.target.dataset.optionIndex);
        if (!Number.isInteger(index) || index < 0 || index > 2) return;
        this.selectedOptions = this.selectedOptions || variantOptions(this.variant);
        this.selectedOptions[index] = event.target.value;
        this.variant = variantForOptions(this.variants, this.selectedOptions);
        this._variantChanged = true;
        this._sync(false);
        return;
      }
      if (event.target.matches('input[name="mobile-color"]')) {
        var value = event.target.value;
        var selected = this.variants.find(function (variant) { return String(variant.id) === String(value); });
        if (selected) {
          this.variant = selected;
          this.selectedOptions = variantOptions(selected);
          this._variantChanged = true;
          this._sync(false);
        }
      } else if (event.target.matches('[data-quantity]')) {
        event.target.value = String(this._quantity());
        this._sync(false);
      }
    }

    _onInput(event) { if (event.target.matches('[data-quantity]')) this._sync(false); }

    _onSubmit(event) {
      var button = this._one('[data-main-submit]');
      if (button && event.target.contains(button)) {
        event.preventDefault();
        this._add(false);
      }
    }

    _onClick(event) {
      var step = event.target.closest('[data-qty-step]');
      if (step && this.contains(step)) {
        event.preventDefault();
        var input = this._one('[data-quantity]');
        var amount = Number(step.dataset.qtyStep);
        if (input && (amount === -1 || amount === 1)) {
          input.value = String(quantityOf(this._quantity() + amount, input.min, input.max));
          this._sync(false);
        }
        return;
      }
      var open = event.target.closest('[data-details-open]');
      var close = event.target.closest('[data-details-close]');
      if (open && this.contains(open) || close && this.contains(close)) {
        event.preventDefault();
        var dialog = this._one('[data-details-dialog]');
        if (dialog) {
          if (open && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
          if (close && typeof dialog.close === 'function') dialog.close();
        }
        return;
      }
      var thumb = event.target.closest('[data-thumb-index]');
      if (thumb && this.contains(thumb)) {
        event.preventDefault();
        var index = thumb.dataset.thumbIndex;
        var image = index === 'lifestyle' ? this.config.lifestyle || this.product.lifestyle : this.images[Number(index)];
        this._setHero(image, index);
        return;
      }
      var main = event.target.closest('[data-main-submit]');
      var bundle = event.target.closest('[data-bundle-submit]');
      if (main && this.contains(main) || bundle && this.contains(bundle)) {
        event.preventDefault();
        this._add(Boolean(bundle));
      }
    }

    _status(message, withCartLink) {
      var status = this._one('[data-status]');
      if (!status) return;
      status.textContent = String(message || '');
      status.hidden = !message;
      if (withCartLink) {
        var link = document.createElement('a');
        link.href = cartRoot(this.dataset.cartRoot);
        link.textContent = this.texts.view_cart || 'View cart';
        status.appendChild(document.createTextNode(' '));
        status.appendChild(link);
      }
    }

    async _add(asSet) {
      if (this._busy || this._alreadyAdded || !purchasable(this.variant) || asSet && !purchasable(this.matched)) return;
      var quantity = this._quantity();
      var input = this._one('[data-quantity]');
      if (input) input.value = String(quantity);
      var items = [{ id: this.variant.id, quantity: quantity }];
      if (asSet) items.push({ id: this.matched.id, quantity: 1 });
      this._busy = true;
      this._buttons();
      this._status(this.texts.adding || 'Adding…');
      try {
        var root = cartRoot(this.dataset.cartRoot);
        var response = await global.fetch(root + '/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        var data;
        try { data = await response.json(); } catch (error) { throw new Error(this.texts.error || 'The cart response could not be confirmed.'); }
        if (!response.ok || !validateAdded(data, items)) {
          throw new Error(data && (data.description || data.message) || this.texts.error || 'The cart could not be updated.');
        }
        this._alreadyAdded = true;
        var rewards = global.ChicCartRewards;
        var ensured = rewards && typeof rewards.ensure === 'function' ? await rewards.ensure() : null;
        var count = ensured && Number(ensured.item_count);
        if (Number.isInteger(count) && count >= 0) this._text('[data-cart-count]', String(count));
        global.location.assign(root);
      } catch (error) {
        var message = this._alreadyAdded ? this.texts.reward_error || 'Your items are in the cart. Review gift and discount eligibility there.' : error.message || this.texts.error || 'Could not add this selection. Please try again.';
        this._status(message, true);
      } finally {
        this._busy = false;
        this._buttons();
      }
    }
  }

  var api = { normalizeTitle: normalizeTitle, optionNames: optionNames, variantOptions: variantOptions, variantForOptions: variantForOptions, optionExists: optionExists, variantColor: variantColor, preferredVariant: preferredVariant, singleDefaultVariant: singleDefaultVariant, matchingCompanion: matchingCompanion, purchasable: purchasable, quantityOf: quantityOf, explicitSaving: explicitSaving, cartRoot: cartRoot, validateAdded: validateAdded, fillTemplate: fillTemplate, ChicMobilePilot: ChicMobilePilot };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (global.customElements && !global.customElements.get('chic-mobile-pilot')) global.customElements.define('chic-mobile-pilot', ChicMobilePilot);
})(typeof window !== 'undefined' ? window : globalThis);
